// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form Designer V1.2 — polished UI pass.

   Cosmetic only. The 48 × 32 square-cell canvas, the card and control
   geometry, the snapping and the panel behaviour all live in JS and are not
   touched here: this file decides type, colour, spacing and elevation.

   Type: Arial 12px is the whole interface. Hierarchy comes from weight, not
   from size — the page title is the one larger element, and 11px is used only
   for metadata that has to share a line with something else (a card's cell
   count, a column's PostgreSQL type, a control caption inside two grid
   cells).

   Colour: white and very light grey surfaces, dark navy for chrome, one blue
   accent, a light blue for selection, grey hairlines, and shadows just strong
   enough to lift a card off the canvas.

   Spacing: one 6px rhythm, one 26px control height, one 3px radius. Every
   band above the canvas is as short as it can be, because the canvas is the
   workspace. */
.efd {
  --efd-ink: #1f2933;
  --efd-muted: #6b7280;
  --efd-line: #e3e8ee;
  --efd-line-strong: #cbd4de;
  --efd-soft: #eef1f5;
  --efd-surface: #ffffff;
  --efd-band: #f7f9fb;
  --efd-chrome: #16324f;
  --efd-primary: #1976d2;
  --efd-primary-dark: #0d47a1;
  --efd-primary-soft: rgba(25, 118, 210, 0.08);
  --efd-danger: #c62828;
  --efd-danger-soft: rgba(198, 40, 40, 0.08);
  --efd-focus-ring: 0 0 0 2px rgba(25, 118, 210, 0.3);
  --efd-selected: #e8f1fb;
  --efd-selected-line: #bcd9f5;
  --efd-grid-faint: #eef1f5;
  --efd-grid-major: #dde4ec;
  --efd-shadow-1: 0 1px 2px rgba(16, 36, 56, 0.06);
  --efd-shadow-2: 0 1px 3px rgba(16, 36, 56, 0.1);
  /* One height for every input, select and button. */
  --efd-control-h: 26px;
  --efd-radius: 3px;
  --efd-gap: 6px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  flex: 1 1;
  color: var(--efd-ink);
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.35;
}

/* The Materialize overlay sets \`font-family: inherit\` on \`.emr-mz-dashboard *\`,
   which ties with a single class and is injected later, so the designer has to
   claim its own type with a two-class selector or it renders in the app's
   Inter stack. Everything inside then inherits Arial from here. */
.emr-mz-dashboard .efd {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
}

/* The same overlay forces \`display: block\` on every semantic element under
   \`.emr-mz-dashboard\`, which also outranks a single designer class. A card is
   a <section> and the panels and rails are <aside>, so without this the card
   stops being a column: its control grid collapses to content height, the
   control cells stop matching the canvas cells, and a control drag maps
   pixels to the wrong rows. */
.emr-mz-dashboard .efd__card,
.emr-mz-dashboard .efd__panel,
.emr-mz-dashboard .efd__rail {
  display: flex;
  flex-direction: column;
}

/* Form controls do not inherit type, so they are told to. Arial 12px is the
   standard here and nothing in the designer opts out of it. */
.efd input,
.efd select,
.efd textarea,
.efd button {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
}

/* Materialize (global, and again under .emr-mz-dashboard) sets
   \`select { display: none }\` and moves native checkboxes off-screen with
   \`position: absolute; opacity: 0\`. The properties panel reads and writes
   control metadata through those controls, so it has to opt back out of both. */
.emr-mz-dashboard .efd select,
.efd select {
  display: block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
}

.emr-mz-dashboard .efd input[type="checkbox"],
.efd input[type="checkbox"] {
  position: static !important;
  left: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: 14px !important;
  height: 14px !important;
  margin: 0 !important;
  z-index: auto !important;
  accent-color: var(--efd-primary);
}

/* The overlay also ships Materialize's input base, which matches
   \`input[type="number"]:not(.browser-default)\` and its text/search siblings at
   a higher specificity than any single designer class can reach. It is an
   underline-only 3rem control with 16px type, an 8px margin and content-box
   sizing — the opposite of a compact property inspector — so the designer's
   fields opt out of it the way the selects and checkboxes above do. */
.emr-mz-dashboard .efd__field input,
.emr-mz-dashboard .efd__field select,
.emr-mz-dashboard .efd__field textarea,
.emr-mz-dashboard .efd__search-input {
  box-sizing: border-box !important;
  height: var(--efd-control-h) !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 7px !important;
  border: 1px solid var(--efd-line-strong) !important;
  border-radius: var(--efd-radius) !important;
  background: var(--efd-surface) !important;
  box-shadow: none !important;
  font-size: 12px !important;
  line-height: normal !important;
}

.emr-mz-dashboard .efd__field textarea {
  height: auto !important;
  padding: 4px 7px !important;
  line-height: 1.4 !important;
}

/* The field search keeps room for the magnifier sitting inside its left edge. */
.emr-mz-dashboard .efd__search-input {
  padding: 0 7px 0 24px !important;
}

.emr-mz-dashboard .efd__field input:focus,
.emr-mz-dashboard .efd__field select:focus,
.emr-mz-dashboard .efd__field textarea:focus,
.emr-mz-dashboard .efd__search-input:focus {
  border: 1px solid var(--efd-primary) !important;
  box-shadow: var(--efd-focus-ring) !important;
}

.emr-mz-dashboard .efd__field input:disabled,
.emr-mz-dashboard .efd__field select:disabled,
.emr-mz-dashboard .efd__field textarea:disabled {
  background: #f5f7f9 !important;
}

/* ---------------------------------------------------------------- toolbar */

/* A desktop application toolbar, not a web page header: one row holding the
   title, the form's four pieces of metadata, and the actions. */
.efd__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 4px 10px;
  padding: 5px 10px 6px;
  margin-bottom: var(--efd-gap);
  background: var(--efd-surface);
  border: 1px solid var(--efd-line);
  border-radius: 4px;
  box-shadow: var(--efd-shadow-1);
}

/* The one element allowed to be larger than 12px. */
.efd__title {
  flex: 0 0 auto;
  align-self: center;
  margin: 0 4px 0 0;
  padding-right: 10px;
  border-right: 1px solid var(--efd-line);
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: var(--efd-chrome);
  white-space: nowrap;
}

.efd__toolbar-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  align-self: flex-end;
  height: var(--efd-control-h);
}

/* Card actions and form actions are separate runs, separated by a hairline. */
.efd__action-group {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.efd__action-group + .efd__action-group,
.efd__toolbar-actions > .efd__btn {
  margin-left: 4px;
  padding-left: 6px;
  border-left: 1px solid var(--efd-line);
}

/* ---------------------------------------------------------------- command bar */

/* Access-style command strip: FORM / CARD / CONTROL, then Save. Labels stay
   visible so these actions are never icon-only canvas secrets. */
.efd__command-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 6px 10px;
  margin-bottom: var(--efd-gap);
  background: var(--efd-surface);
  border: 1px solid var(--efd-line);
  border-radius: 4px;
  box-shadow: var(--efd-shadow-1);
}

.efd__command-group {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.efd__command-group + .efd__command-group {
  padding-left: 10px;
  border-left: 1px solid var(--efd-line);
}

.efd__command-group--end {
  margin-left: auto;
  border-left: none;
  padding-left: 0;
}

.efd__cmd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: var(--efd-control-h);
  padding: 0 10px;
  border: 1px solid var(--efd-line-strong);
  border-radius: var(--efd-radius);
  background: var(--efd-surface);
  color: var(--efd-primary-dark);
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}

.efd__cmd:hover:not(:disabled) {
  background: var(--efd-primary-soft);
  border-color: var(--efd-primary);
  color: var(--efd-primary-dark);
}

.efd__cmd:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__cmd:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.efd__cmd--danger {
  color: var(--efd-danger);
  border-color: #ef9a9a;
}

.efd__cmd--danger:hover:not(:disabled) {
  background: var(--efd-danger-soft);
  border-color: var(--efd-danger);
  color: var(--efd-danger);
}

.efd__palette-tabs {
  display: flex;
  margin: 0 8px 6px;
  border-bottom: 1px solid var(--efd-line);
}

.efd__palette-tab {
  flex: 1 1;
  height: 26px;
  padding: 0 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--efd-muted);
  font-weight: 700;
  cursor: pointer;
}

.efd__palette-tab.is-active {
  color: var(--efd-primary-dark);
  border-bottom-color: var(--efd-primary);
}

.efd__palette-item--semantic.is-composite .efd__palette-name {
  font-weight: 700;
}

.efd__semantic-caret {
  display: inline-flex;
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  color: var(--efd-muted);
}

.efd__semantic-resource {
  margin-bottom: 6px;
}

.efd__semantic-resource.is-empty .efd__palette-empty {
  padding-top: 0;
}

.efd__confirm {
  font-family: Arial, Helvetica, sans-serif;
}

/* ---------------------------------------------------------------- buttons */

.efd__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: var(--efd-control-h);
  padding: 0 12px;
  border: 1px solid var(--efd-line-strong);
  border-radius: var(--efd-radius);
  background: var(--efd-surface);
  color: var(--efd-ink);
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}

.efd__btn-icon {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

.efd__btn:hover:not(:disabled) {
  background: var(--efd-primary-soft);
  border-color: var(--efd-primary);
  color: var(--efd-primary-dark);
}

.efd__btn:active:not(:disabled) {
  background: rgba(25, 118, 210, 0.16);
}

.efd__btn:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__btn--primary {
  background: var(--efd-primary);
  border-color: var(--efd-primary);
  color: #fff;
}

.efd__btn--primary:hover:not(:disabled) {
  background: #1565c0;
  border-color: #1565c0;
  color: #fff;
}

.efd__btn--primary:active:not(:disabled) {
  background: var(--efd-primary-dark);
  border-color: var(--efd-primary-dark);
}

.efd__btn--ghost {
  background: transparent;
  border-color: transparent;
  color: var(--efd-primary-dark);
  font-weight: 700;
}

.efd__btn--ghost:hover:not(:disabled) {
  background: var(--efd-primary-soft);
  border-color: transparent;
}

.efd__btn--danger {
  color: var(--efd-danger);
}

.efd__btn--danger:hover:not(:disabled) {
  background: var(--efd-danger-soft);
  border-color: transparent;
  color: var(--efd-danger);
}

.efd__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Icon-only toolbar action. The meaning is carried by the glyph, its colour
   and its tooltip — Add is the accent, Delete is the one warning colour. */
.efd__tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--efd-control-h);
  height: var(--efd-control-h);
  padding: 0;
  flex: 0 0 auto;
  border: 1px solid transparent;
  border-radius: var(--efd-radius);
  background: transparent;
  color: var(--efd-primary);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.efd__tool-btn:hover:not(:disabled) {
  background: var(--efd-primary-soft);
  color: var(--efd-primary-dark);
}

.efd__tool-btn:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__tool-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.efd__tool-btn--danger {
  color: var(--efd-danger);
}

.efd__tool-btn--danger:hover:not(:disabled) {
  background: var(--efd-danger-soft);
  color: var(--efd-danger);
}

/* Square icon-only affordance: panel collapse/expand. */
.efd__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  flex: 0 0 auto;
  border: 1px solid transparent;
  border-radius: var(--efd-radius);
  background: transparent;
  color: var(--efd-muted);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.efd__icon-btn:hover {
  background: var(--efd-primary-soft);
  color: var(--efd-primary-dark);
}

.efd__icon-btn:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__icon {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

/* ---------------------------------------------------------------- toolbox */

/* Access-style control toolbar, in three named runs. Separate from Database
   Fields: this row is what you can put on the form, not the PostgreSQL
   columns that bind later. */
.efd__toolbox {
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-bottom: var(--efd-gap);
  padding: 3px 8px 4px;
  background: var(--efd-surface);
  border: 1px solid var(--efd-line);
  border-radius: 4px;
  box-shadow: var(--efd-shadow-1);
  min-width: 0;
}

.efd__toolbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 0 10px 0 2px;
  border-right: 1px solid var(--efd-line);
  color: var(--efd-chrome);
}

.efd__toolbox-label .efd__icon {
  color: var(--efd-primary);
}

.efd__toolbox-kicker {
  font-weight: 700;
  white-space: nowrap;
}

.efd__toolbox-items {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0 4px;
  min-width: 0;
}

/* A group is a label over its own run of controls, with a hairline between
   runs. Subtle enough that the row still reads as one toolbar. */
.efd__toolbox-group {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 8px;
  min-width: 0;
}

.efd__toolbox-group + .efd__toolbox-group {
  border-left: 1px solid var(--efd-line);
}

.efd__toolbox-group-title {
  font-size: 11px;
  font-weight: 700;
  line-height: 13px;
  color: var(--efd-muted);
  white-space: nowrap;
}

.efd__toolbox-group-items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.efd__toolbox-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 24px;
  padding: 0 7px;
  border: 1px solid transparent;
  border-radius: var(--efd-radius);
  background: transparent;
  color: var(--efd-ink);
  line-height: 1;
  white-space: nowrap;
  cursor: grab;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}

.efd__toolbox-item:hover:not(:disabled) {
  background: var(--efd-primary-soft);
  border-color: rgba(25, 118, 210, 0.3);
  color: var(--efd-primary-dark);
}

.efd__toolbox-item:active:not(:disabled) {
  background: rgba(25, 118, 210, 0.16);
}

.efd__toolbox-item:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__toolbox-item:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.efd__toolbox-glyph {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  color: var(--efd-primary);
}

.efd__toolbox-name {
  font-size: 12px;
}

/* ----------------------------------------------------------- form fields */

.efd__field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 6px;
  min-width: 0;
}

.efd__field--inline {
  margin-bottom: 0;
  min-width: 140px;
}

.efd__field--grow {
  flex: 1 1;
  min-width: 180px;
}

.efd__field label {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: var(--efd-muted);
}

.efd__field input,
.efd__field select,
.efd__field textarea,
.efd__search-input {
  height: var(--efd-control-h);
  border: 1px solid var(--efd-line-strong);
  border-radius: var(--efd-radius);
  padding: 0 7px;
  background: var(--efd-surface);
  color: var(--efd-ink);
  min-width: 0;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.efd__field textarea {
  height: auto;
  padding: 4px 7px;
  line-height: 1.4;
  resize: vertical;
}

.efd__field input:hover:not(:disabled),
.efd__field select:hover:not(:disabled),
.efd__field textarea:hover:not(:disabled),
.efd__search-input:hover {
  border-color: #9aa7b3;
}

.efd__field input:focus,
.efd__field select:focus,
.efd__field textarea:focus,
.efd__search-input:focus {
  outline: none;
  border-color: var(--efd-primary);
  box-shadow: var(--efd-focus-ring);
}

.efd__field input:disabled,
.efd__field select:disabled,
.efd__field textarea:disabled {
  background: #f5f7f9;
  color: var(--efd-muted);
  cursor: not-allowed;
}

.efd__toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 22px;
  margin-bottom: 4px;
  color: var(--efd-ink);
  cursor: pointer;
}

/* -------------------------------------------------------------- workspace */

/* Three regions: Database Fields, canvas, Properties. The canvas is the
   workspace, so the inspectors are sized to their content and everything else
   goes to the middle. Collapsing a panel hands its whole column to the canvas
   and leaves a rail just wide enough to bring it back. */
.efd__workspace {
  display: grid;
  grid-template-columns:
    clamp(176px, 13vw, 224px)
    minmax(0, 1fr)
    clamp(212px, 15vw, 248px);
  gap: var(--efd-gap);
  flex: 1 1;
  min-height: 0;
}

.efd__workspace--no-left {
  grid-template-columns: 30px minmax(0, 1fr) clamp(212px, 15vw, 248px);
}

.efd__workspace--no-right {
  grid-template-columns: clamp(176px, 13vw, 224px) minmax(0, 1fr) 30px;
}

.efd__workspace--no-left.efd__workspace--no-right {
  grid-template-columns: 30px minmax(0, 1fr) 30px;
}

.efd__panel {
  display: flex;
  flex-direction: column;
  background: var(--efd-surface);
  border: 1px solid var(--efd-line);
  border-radius: 4px;
  box-shadow: var(--efd-shadow-1);
  padding: 0 8px 8px;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}

/* The panel's own title band, edge to edge above its content. */
.efd__panel-head {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  z-index: 2;
  margin: 0 -8px 6px;
  padding: 4px 6px 4px 8px;
  background: var(--efd-band);
  border-bottom: 1px solid var(--efd-line);
}

.efd__panel-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--efd-chrome);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__panel-title .efd__icon {
  color: var(--efd-primary);
}

.efd__panel-note {
  margin: 0 0 6px;
  font-size: 11px;
  color: var(--efd-muted);
}

/* The collapsed rail: one expand button and the panel's name turned on its
   side, so the panel is still findable at 30px. */
.efd__rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 5px 2px;
  background: var(--efd-surface);
  border: 1px solid var(--efd-line);
  border-radius: 4px;
  box-shadow: var(--efd-shadow-1);
  overflow: hidden;
}

.efd__rail-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  writing-mode: vertical-rl;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--efd-muted);
  white-space: nowrap;
}

.efd__rail-label .efd__icon {
  width: 16px;
  height: 16px;
  color: var(--efd-primary);
}

/* -------------------------------------------------------- database fields */

.efd__search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  margin-bottom: 6px;
}

.efd__search-icon {
  position: absolute;
  left: 6px;
  width: 13px;
  height: 13px;
  color: var(--efd-muted);
  pointer-events: none;
}

.efd__search-input {
  width: 100%;
  padding-left: 24px;
}

/* The table the fields belong to, named the way the user thinks of it. The
   raw table name is not the headline — it is the row's tooltip. */
.efd__palette-table {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 3px 6px;
  margin-bottom: 4px;
  border-radius: var(--efd-radius);
  background: var(--efd-band);
  border: 1px solid var(--efd-line);
  color: var(--efd-chrome);
}

.efd__palette-table .efd__icon {
  color: var(--efd-primary);
}

.efd__palette-table-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}

.efd__palette-table-eyebrow {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--efd-muted);
}

.efd__palette-table-name {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__palette-group {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-height: 0;
  overflow: auto;
}

.efd__palette-empty {
  margin: 2px 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--efd-muted);
}

/* A field row: a type glyph, the human label, and the control family under it
   as quieter metadata. Two compact lines, the way an Access field list reads —
   the database column itself is in the row's tooltip, not in the list. */
.efd__palette-item {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  border-left: 2px solid transparent;
  border-radius: var(--efd-radius);
  padding: 2px 6px;
  background: transparent;
  cursor: grab;
  transition: background-color 120ms ease, border-color 120ms ease;
}

.efd__palette-item:hover:not(:disabled) {
  background: var(--efd-primary-soft);
  border-color: rgba(25, 118, 210, 0.25);
  border-left-color: var(--efd-primary);
}

.efd__palette-item:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

/* A database field and a toolbox control must never look alike. */
.efd__palette-item--field {
  border-left-color: var(--efd-primary);
}

.efd__palette-item.is-used {
  opacity: 0.5;
}

.efd__palette-item:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.efd__palette-glyph {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
  color: var(--efd-muted);
}

.efd__palette-item:hover .efd__palette-glyph {
  color: var(--efd-primary);
}

.efd__palette-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}

.efd__palette-name {
  min-width: 0;
  font-size: 12px;
  line-height: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__palette-required {
  margin-left: 2px;
  color: var(--efd-danger);
}

/* The control family, not the PostgreSQL type: what the field IS to a user. */
.efd__palette-type {
  min-width: 0;
  font-size: 11px;
  line-height: 13px;
  color: var(--efd-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Keys, audit columns and system plumbing: present, reachable, de-emphasised. */
.efd__palette-item.is-technical .efd__palette-name {
  color: var(--efd-muted);
}

.efd__palette-group-title {
  margin: 6px 0 2px;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--efd-muted);
  border-top: 1px solid var(--efd-line);
  padding-top: 5px;
}

.efd__palette-toggle {
  flex: 0 0 auto;
  margin: 4px 0 0;
  padding-top: 5px;
  border-top: 1px solid var(--efd-line);
  font-size: 11px;
  color: var(--efd-muted);
}

/* ----------------------------------------------------------------- canvas */

/* The design surface itself. There is no second rendering of the form: what
   is on this canvas is the form being designed. The grid belongs to this
   canvas — empty space shows the same square cells cards and controls snap
   to. */
.efd__canvas {
  display: flex;
  flex-direction: column;
  background: var(--efd-soft);
  border: 1px solid var(--efd-line);
  border-radius: 4px;
  padding: 10px;
  min-width: 0;
  overflow: auto;
}

/* 48 × 32 SQUARE cells. The aspect ratio is what makes them square: the row
   height is never stated in pixels, it falls out of the width. Below
   --efd-min-cell a cell stops being a usable target, so the surface keeps its
   proportions and the canvas scrolls instead.

   Minor lines are barely there and major lines every eight cells are only a
   shade stronger: the grid has to be readable without competing with the form
   drawn on top of it. */
.efd__canvas-grid {
  --efd-major: 8;
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  min-width: calc(var(--efd-cols) * var(--efd-min-cell, 21px));
  background-color: var(--efd-surface);
  background-image:
    linear-gradient(to right, var(--efd-grid-major) 1px, transparent 1px),
    linear-gradient(to bottom, var(--efd-grid-major) 1px, transparent 1px),
    linear-gradient(to right, var(--efd-grid-faint) 1px, transparent 1px),
    linear-gradient(to bottom, var(--efd-grid-faint) 1px, transparent 1px);
  background-size:
    calc(100% / var(--efd-cols) * var(--efd-major)) 100%,
    100% calc(100% / var(--efd-rows) * var(--efd-major)),
    calc(100% / var(--efd-cols)) 100%,
    100% calc(100% / var(--efd-rows));
  background-position: 0 0;
  background-repeat: repeat;
  border: 1px solid var(--efd-line-strong);
  border-radius: 3px;
  box-shadow: var(--efd-shadow-2);
}

.efd__empty {
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 0;
  max-width: 400px;
  padding: 14px 18px;
  border: 1px dashed var(--efd-line-strong);
  border-radius: 4px;
  text-align: center;
  line-height: 1.45;
  color: var(--efd-muted);
  background: rgba(255, 255, 255, 0.94);
}

.efd__empty-copy {
  margin: 0;
}

/* ------------------------------------------------------------------ cards */

/* A card is a titled section sitting on the canvas grid. Its box is exactly
   col/row/width/height cells — the header is the first row of that box, so the
   card's own control grid is the canvas grid, cropped. */
.efd__card {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: var(--efd-surface);
  border: 1px solid #d3dce5;
  border-radius: 3px;
  margin: 0;
  overflow: hidden;
  box-shadow: var(--efd-shadow-1);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.efd__card:hover {
  border-color: #b8c5d2;
}

/* Selected: a clear blue outline and a tinted header, and nothing more. */
.efd__card.is-selected {
  border-color: var(--efd-primary);
  box-shadow: 0 0 0 1px var(--efd-primary), var(--efd-shadow-2);
}

/* \`.emr-mz-dashboard header\` forces display:block at a higher specificity than
   a single class, so the card header has to claim its flex row twice. The band
   is exactly one canvas cell tall: the card is --efd-card-rows cells high. */
.emr-mz-dashboard .efd__card-head,
.efd__card-head {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 calc(100% / var(--efd-card-rows, 7));
  min-height: 0;
  padding: 0 2px 0 6px;
  border-bottom: 1px solid var(--efd-line);
  background: var(--efd-band);
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
}

.efd__card.is-selected .efd__card-head {
  background: var(--efd-selected);
  border-bottom-color: var(--efd-selected-line);
}

.efd__drag-handle {
  display: grid;
  grid-template-columns: repeat(3, 3px);
  gap: 2px;
  flex: 0 0 auto;
  cursor: grab;
}

.efd__drag-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #9aa8b5;
}

.efd__card.is-selected .efd__drag-dot {
  background: var(--efd-primary);
}

.efd__card-title {
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__card-meta {
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 1.2;
  color: var(--efd-muted);
  white-space: nowrap;
}

.efd__card-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  flex: 0 0 auto;
  border: none;
  border-radius: 2px;
  background: transparent;
  color: var(--efd-muted);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.efd__card-close:hover {
  background: var(--efd-danger-soft);
  color: var(--efd-danger);
}

.efd__card-close:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__card-close-icon {
  width: 12px;
  height: 12px;
}

/* The card's control grid: its own columns across, its own cells down. Both
   come from the card's canvas box, so a control cell IS a canvas cell — and
   the card draws those same cells, fainter than the canvas does, so a control
   is placed against a visible grid and reads as sitting on top of it. */
.efd__card-grid {
  display: grid;
  flex: 1 1 auto;
  min-height: 0;
  grid-template-columns: repeat(var(--efd-cols), minmax(0, 1fr));
  grid-template-rows: repeat(var(--efd-rows), minmax(0, 1fr));
  gap: 0;
  padding: 0;
  background-color: transparent;
  background-image:
    linear-gradient(to right, var(--efd-grid-faint) 1px, transparent 1px),
    linear-gradient(to bottom, var(--efd-grid-faint) 1px, transparent 1px);
  background-size:
    calc(100% / var(--efd-cols)) 100%,
    100% calc(100% / var(--efd-rows));
  background-repeat: repeat;
}

.efd__card-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 13px;
  height: 13px;
  cursor: nwse-resize;
  background: linear-gradient(135deg, transparent 50%, #aab8c4 50%);
  touch-action: none;
  z-index: 2;
}

.efd__card.is-selected .efd__card-handle {
  background: linear-gradient(135deg, transparent 50%, var(--efd-primary) 50%);
}

/* --------------------------------------------------------------- controls */

/* A control should read as the form control it will become, sitting above the
   grid — not as a filled spreadsheet cell. The box itself is quiet; the input,
   button or box inside it carries the shape. */
.efd__control {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1px;
  margin: 1px;
  padding: 1px 3px;
  border: 1px solid transparent;
  border-radius: var(--efd-radius);
  background: var(--efd-surface);
  cursor: grab;
  overflow: hidden;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.efd__control:hover {
  border-color: var(--efd-line-strong);
  box-shadow: var(--efd-shadow-1);
}

/* Selection has to survive against a grid of similar rectangles, so it changes
   border, fill and halo together rather than relying on any one of them. */
.efd__control.is-selected {
  border-color: var(--efd-primary);
  background: var(--efd-selected);
  box-shadow: 0 0 0 1px var(--efd-primary);
  z-index: 1;
}

/* A control with no caption draws its own shape — a button, a rule, a box —
   so it is aligned to the top left of its cells rather than centred. */
.efd__control--label,
.efd__control--button,
.efd__control--line,
.efd__control--rectangle,
.efd__control--image,
.efd__control--tab {
  justify-content: center;
  align-items: flex-start;
}

.efd__control--line {
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.efd__control-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 9px;
  height: 9px;
  cursor: nwse-resize;
  background: linear-gradient(135deg, transparent 50%, var(--efd-primary) 50%);
  touch-action: none;
  opacity: 0;
  transition: opacity 120ms ease;
}

.efd__control:hover .efd__control-handle,
.efd__control.is-selected .efd__control-handle {
  opacity: 1;
}

/* A two-row control is the tightest case: a caption line over an input inside
   two square cells. The caption is the one place 11px is unavoidable — it has
   to share a ~40px box with a real input — and it keeps its whole line box or
   the glyph tops are clipped. */
.efd__preview-caption {
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--efd-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__preview-required {
  color: var(--efd-danger);
}

.efd__preview-input {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--efd-line-strong);
  border-radius: 2px;
  background: var(--efd-surface);
  color: var(--efd-muted);
  padding: 0 5px;
  min-height: 18px;
}

.efd__preview-input--tall {
  flex: 1 1;
  align-items: flex-start;
  padding-top: 2px;
}

.efd__preview-caret {
  color: var(--efd-muted);
  font-size: 11px;
  margin-left: 4px;
}

.efd__preview-check {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__preview-box {
  width: 13px;
  height: 13px;
  border: 1px solid #8b9aa8;
  border-radius: 2px;
  background: var(--efd-surface);
  flex-shrink: 0;
}

.efd__preview-radio {
  width: 13px;
  height: 13px;
  border: 1px solid #8b9aa8;
  border-radius: 50%;
  background: var(--efd-surface);
  flex-shrink: 0;
}

.efd__preview-label {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__preview-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--efd-primary);
  color: #fff;
  border-radius: 2px;
  padding: 0 10px;
  min-height: 20px;
  max-width: 100%;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__preview-line {
  display: block;
  width: 100%;
  height: 0;
  border-top: 2px solid #8b9aa8;
}

.efd__preview-rect {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 16px;
  border: 1px solid #8b9aa8;
  border-radius: 2px;
  color: var(--efd-muted);
  font-size: 11px;
}

.efd__preview-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 22px;
  border-radius: 2px;
  background:
    linear-gradient(135deg, transparent 46%, #cdd7e0 46%, #cdd7e0 54%, transparent 54%),
    #f4f6f9;
  color: var(--efd-muted);
  font-size: 11px;
}

.efd__preview-tabs {
  display: flex;
  gap: 3px;
  width: 100%;
  border-bottom: 1px solid var(--efd-line-strong);
}

.efd__preview-tab {
  padding: 1px 8px;
  font-size: 11px;
  color: var(--efd-muted);
  border: 1px solid transparent;
}

.efd__preview-tab.is-active {
  color: var(--efd-ink);
  background: var(--efd-surface);
  border-color: var(--efd-line-strong);
  border-bottom-color: var(--efd-surface);
  font-weight: 700;
}

.efd__preview-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  border: 1px solid var(--efd-line-strong);
  border-radius: 2px;
  background: var(--efd-surface);
  font-size: 11px;
  color: var(--efd-muted);
  padding: 1px 5px;
  overflow: hidden;
}

/* ------------------------------------------------------------- properties */

/* A property inspector: a few titled sections of label/value rows, each row
   one line high. Nothing here is allowed to waste vertical space. */
.efd__props-kind {
  flex: 0 0 auto;
  padding: 1px 6px;
  border-radius: 8px;
  background: var(--efd-selected);
  border: 1px solid var(--efd-selected-line);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--efd-primary-dark);
}

.efd__group {
  margin: 0;
  border-bottom: 1px solid var(--efd-line);
}

.efd__group:last-of-type {
  border-bottom: none;
}

/* The section header is also its toggle: a caret, a name, nothing else. */
.efd__group-title {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  margin: 0;
  padding: 5px 0 4px;
  border: none;
  background: transparent;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--efd-muted);
  text-align: left;
  cursor: pointer;
}

.efd__group-title:hover {
  color: var(--efd-primary-dark);
}

.efd__group-title:focus-visible {
  outline: none;
  box-shadow: var(--efd-focus-ring);
}

.efd__group-caret {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
  color: var(--efd-muted);
  transform: rotate(-90deg);
  transition: transform 120ms ease;
}

.efd__group.is-open .efd__group-caret {
  transform: rotate(0deg);
}

.efd__group-body {
  padding: 0 0 6px;
}

/* Two columns: the property's name, then its value. Every row is the same
   shape, so the panel reads down its left edge. */
.efd__props .efd__field {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.efd__props .efd__field label {
  font-size: 12px;
  line-height: 14px;
  color: var(--efd-muted);
  overflow: hidden;
  text-overflow: ellipsis;
}

.efd__props .efd__field textarea {
  grid-column: 1 / -1;
}

.efd__props .efd__field:has(textarea) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2px;
}

.efd__props .efd__toggle {
  margin-bottom: 4px;
}

.efd__group-body > .efd__field:last-child,
.efd__group-body > .efd__toggle:last-child {
  margin-bottom: 0;
}

.efd__prop-value {
  min-height: 22px;
  display: flex;
  align-items: center;
  word-break: break-word;
}

.efd__prop-value--binding {
  font-family: "IBM Plex Mono", ui-monospace, Menlo, Consolas, monospace;
  font-size: 12px;
  color: var(--efd-primary-dark);
}

.efd__props-note {
  margin: 6px 0 0;
  font-size: 11px;
  line-height: 1.45;
  color: var(--efd-muted);
}

.efd__prop-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--efd-line);
}

.efd__prop-actions .efd__btn {
  height: 24px;
  padding: 0 8px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-form-designer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;eAkBe;AACf;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,4CAA4C;EAC5C,qBAAqB;EACrB,0CAA0C;EAC1C,mDAAmD;EACnD,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,gDAAgD;EAChD,+CAA+C;EAC/C,mDAAmD;EACnD,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAO;EACP,qBAAqB;EACrB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;kEAGkE;AAClE;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;;;;;8BAK8B;AAC9B;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;8DAC8D;AAC9D;;;;EAIE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;;;gFAGgF;AAChF;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;;;;sEAKsE;AACtE;;;;EAIE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,mDAAmD;EACnD,2CAA2C;EAC3C,yCAAyC;EACzC,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,gFAAgF;AAChF;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA,6EAA6E;;AAE7E;gEACgE;AAChE;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA,iFAAiF;;AAEjF;iEACiE;AACjE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;EACf,wCAAwC;EACxC,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,6EAA6E;;AAE7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;EACf,wCAAwC;EACxC,gCAAgC;EAChC,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;2EAC2E;AAC3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6EAA6E;;AAE7E;;6BAE6B;AAC7B;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,6BAA6B;EAC7B,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;iEACiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;EAIE,4BAA4B;EAC5B,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,aAAa;EACb,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;;EAGE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,6EAA6E;;AAE7E;;;yDAGyD;AACzD;EACE,aAAa;EACb;;;6BAG2B;EAC3B,mBAAmB;EACnB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;kDACkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;kEACkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;yEAEyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA,kEAAkE;AAClE;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,uBAAuB;AACzB;;AAEA,6EAA6E;;AAE7E;;;QAGQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;;wBAOwB;AACxB;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,4DAA4D;EAC5D,oCAAoC;EACpC;;;;0EAIwE;EACxE;;;;qCAImC;EACnC,wBAAwB;EACxB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA,6EAA6E;;AAE7E;;yDAEyD;AACzD;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;;6EAE6E;AAC7E;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;EAC9C,aAAa;EACb,oBAAoB;EACpB,wCAAwC;EACxC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;wEAGwE;AACxE;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,8DAA8D;EAC9D,2DAA2D;EAC3D,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B;;0EAEwE;EACxE;;qCAEmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iEAAiE;EACjE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,6EAA6E;;AAE7E;;+CAE+C;AAC/C;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;2EAC2E;AAC3E;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,wCAAwC;EACxC,UAAU;AACZ;;AAEA;uEACuE;AACvE;;;;;;EAME,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,4EAA4E;EAC5E,kBAAkB;EAClB,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;gCAGgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB;;WAES;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,oCAAoC;EACpC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6EAA6E;;AAE7E;oEACoE;AACpE;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;kDACkD;AAClD;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sEAAsE;EACtE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Form Designer V1.2 — polished UI pass.\n\n   Cosmetic only. The 48 × 32 square-cell canvas, the card and control\n   geometry, the snapping and the panel behaviour all live in JS and are not\n   touched here: this file decides type, colour, spacing and elevation.\n\n   Type: Arial 12px is the whole interface. Hierarchy comes from weight, not\n   from size — the page title is the one larger element, and 11px is used only\n   for metadata that has to share a line with something else (a card's cell\n   count, a column's PostgreSQL type, a control caption inside two grid\n   cells).\n\n   Colour: white and very light grey surfaces, dark navy for chrome, one blue\n   accent, a light blue for selection, grey hairlines, and shadows just strong\n   enough to lift a card off the canvas.\n\n   Spacing: one 6px rhythm, one 26px control height, one 3px radius. Every\n   band above the canvas is as short as it can be, because the canvas is the\n   workspace. */\n.efd {\n  --efd-ink: #1f2933;\n  --efd-muted: #6b7280;\n  --efd-line: #e3e8ee;\n  --efd-line-strong: #cbd4de;\n  --efd-soft: #eef1f5;\n  --efd-surface: #ffffff;\n  --efd-band: #f7f9fb;\n  --efd-chrome: #16324f;\n  --efd-primary: #1976d2;\n  --efd-primary-dark: #0d47a1;\n  --efd-primary-soft: rgba(25, 118, 210, 0.08);\n  --efd-danger: #c62828;\n  --efd-danger-soft: rgba(198, 40, 40, 0.08);\n  --efd-focus-ring: 0 0 0 2px rgba(25, 118, 210, 0.3);\n  --efd-selected: #e8f1fb;\n  --efd-selected-line: #bcd9f5;\n  --efd-grid-faint: #eef1f5;\n  --efd-grid-major: #dde4ec;\n  --efd-shadow-1: 0 1px 2px rgba(16, 36, 56, 0.06);\n  --efd-shadow-2: 0 1px 3px rgba(16, 36, 56, 0.1);\n  /* One height for every input, select and button. */\n  --efd-control-h: 26px;\n  --efd-radius: 3px;\n  --efd-gap: 6px;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  flex: 1;\n  color: var(--efd-ink);\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n/* The Materialize overlay sets `font-family: inherit` on `.emr-mz-dashboard *`,\n   which ties with a single class and is injected later, so the designer has to\n   claim its own type with a two-class selector or it renders in the app's\n   Inter stack. Everything inside then inherits Arial from here. */\n.emr-mz-dashboard .efd {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 12px;\n}\n\n/* The same overlay forces `display: block` on every semantic element under\n   `.emr-mz-dashboard`, which also outranks a single designer class. A card is\n   a <section> and the panels and rails are <aside>, so without this the card\n   stops being a column: its control grid collapses to content height, the\n   control cells stop matching the canvas cells, and a control drag maps\n   pixels to the wrong rows. */\n.emr-mz-dashboard .efd__card,\n.emr-mz-dashboard .efd__panel,\n.emr-mz-dashboard .efd__rail {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Form controls do not inherit type, so they are told to. Arial 12px is the\n   standard here and nothing in the designer opts out of it. */\n.efd input,\n.efd select,\n.efd textarea,\n.efd button {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 12px;\n}\n\n/* Materialize (global, and again under .emr-mz-dashboard) sets\n   `select { display: none }` and moves native checkboxes off-screen with\n   `position: absolute; opacity: 0`. The properties panel reads and writes\n   control metadata through those controls, so it has to opt back out of both. */\n.emr-mz-dashboard .efd select,\n.efd select {\n  display: block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n}\n\n.emr-mz-dashboard .efd input[type=\"checkbox\"],\n.efd input[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  width: 14px !important;\n  height: 14px !important;\n  margin: 0 !important;\n  z-index: auto !important;\n  accent-color: var(--efd-primary);\n}\n\n/* The overlay also ships Materialize's input base, which matches\n   `input[type=\"number\"]:not(.browser-default)` and its text/search siblings at\n   a higher specificity than any single designer class can reach. It is an\n   underline-only 3rem control with 16px type, an 8px margin and content-box\n   sizing — the opposite of a compact property inspector — so the designer's\n   fields opt out of it the way the selects and checkboxes above do. */\n.emr-mz-dashboard .efd__field input,\n.emr-mz-dashboard .efd__field select,\n.emr-mz-dashboard .efd__field textarea,\n.emr-mz-dashboard .efd__search-input {\n  box-sizing: border-box !important;\n  height: var(--efd-control-h) !important;\n  min-height: 0 !important;\n  margin: 0 !important;\n  padding: 0 7px !important;\n  border: 1px solid var(--efd-line-strong) !important;\n  border-radius: var(--efd-radius) !important;\n  background: var(--efd-surface) !important;\n  box-shadow: none !important;\n  font-size: 12px !important;\n  line-height: normal !important;\n}\n\n.emr-mz-dashboard .efd__field textarea {\n  height: auto !important;\n  padding: 4px 7px !important;\n  line-height: 1.4 !important;\n}\n\n/* The field search keeps room for the magnifier sitting inside its left edge. */\n.emr-mz-dashboard .efd__search-input {\n  padding: 0 7px 0 24px !important;\n}\n\n.emr-mz-dashboard .efd__field input:focus,\n.emr-mz-dashboard .efd__field select:focus,\n.emr-mz-dashboard .efd__field textarea:focus,\n.emr-mz-dashboard .efd__search-input:focus {\n  border: 1px solid var(--efd-primary) !important;\n  box-shadow: var(--efd-focus-ring) !important;\n}\n\n.emr-mz-dashboard .efd__field input:disabled,\n.emr-mz-dashboard .efd__field select:disabled,\n.emr-mz-dashboard .efd__field textarea:disabled {\n  background: #f5f7f9 !important;\n}\n\n/* ---------------------------------------------------------------- toolbar */\n\n/* A desktop application toolbar, not a web page header: one row holding the\n   title, the form's four pieces of metadata, and the actions. */\n.efd__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 4px 10px;\n  padding: 5px 10px 6px;\n  margin-bottom: var(--efd-gap);\n  background: var(--efd-surface);\n  border: 1px solid var(--efd-line);\n  border-radius: 4px;\n  box-shadow: var(--efd-shadow-1);\n}\n\n/* The one element allowed to be larger than 12px. */\n.efd__title {\n  flex: 0 0 auto;\n  align-self: center;\n  margin: 0 4px 0 0;\n  padding-right: 10px;\n  border-right: 1px solid var(--efd-line);\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  color: var(--efd-chrome);\n  white-space: nowrap;\n}\n\n.efd__toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  align-self: flex-end;\n  height: var(--efd-control-h);\n}\n\n/* Card actions and form actions are separate runs, separated by a hairline. */\n.efd__action-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.efd__action-group + .efd__action-group,\n.efd__toolbar-actions > .efd__btn {\n  margin-left: 4px;\n  padding-left: 6px;\n  border-left: 1px solid var(--efd-line);\n}\n\n/* ---------------------------------------------------------------- command bar */\n\n/* Access-style command strip: FORM / CARD / CONTROL, then Save. Labels stay\n   visible so these actions are never icon-only canvas secrets. */\n.efd__command-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 10px;\n  padding: 6px 10px;\n  margin-bottom: var(--efd-gap);\n  background: var(--efd-surface);\n  border: 1px solid var(--efd-line);\n  border-radius: 4px;\n  box-shadow: var(--efd-shadow-1);\n}\n\n.efd__command-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.efd__command-group + .efd__command-group {\n  padding-left: 10px;\n  border-left: 1px solid var(--efd-line);\n}\n\n.efd__command-group--end {\n  margin-left: auto;\n  border-left: none;\n  padding-left: 0;\n}\n\n.efd__cmd {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  height: var(--efd-control-h);\n  padding: 0 10px;\n  border: 1px solid var(--efd-line-strong);\n  border-radius: var(--efd-radius);\n  background: var(--efd-surface);\n  color: var(--efd-primary-dark);\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n\n.efd__cmd:hover:not(:disabled) {\n  background: var(--efd-primary-soft);\n  border-color: var(--efd-primary);\n  color: var(--efd-primary-dark);\n}\n\n.efd__cmd:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__cmd:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.efd__cmd--danger {\n  color: var(--efd-danger);\n  border-color: #ef9a9a;\n}\n\n.efd__cmd--danger:hover:not(:disabled) {\n  background: var(--efd-danger-soft);\n  border-color: var(--efd-danger);\n  color: var(--efd-danger);\n}\n\n.efd__palette-tabs {\n  display: flex;\n  margin: 0 8px 6px;\n  border-bottom: 1px solid var(--efd-line);\n}\n\n.efd__palette-tab {\n  flex: 1;\n  height: 26px;\n  padding: 0 6px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--efd-muted);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.efd__palette-tab.is-active {\n  color: var(--efd-primary-dark);\n  border-bottom-color: var(--efd-primary);\n}\n\n.efd__palette-item--semantic.is-composite .efd__palette-name {\n  font-weight: 700;\n}\n\n.efd__semantic-caret {\n  display: inline-flex;\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n  color: var(--efd-muted);\n}\n\n.efd__semantic-resource {\n  margin-bottom: 6px;\n}\n\n.efd__semantic-resource.is-empty .efd__palette-empty {\n  padding-top: 0;\n}\n\n.efd__confirm {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n/* ---------------------------------------------------------------- buttons */\n\n.efd__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  height: var(--efd-control-h);\n  padding: 0 12px;\n  border: 1px solid var(--efd-line-strong);\n  border-radius: var(--efd-radius);\n  background: var(--efd-surface);\n  color: var(--efd-ink);\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n\n.efd__btn-icon {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n}\n\n.efd__btn:hover:not(:disabled) {\n  background: var(--efd-primary-soft);\n  border-color: var(--efd-primary);\n  color: var(--efd-primary-dark);\n}\n\n.efd__btn:active:not(:disabled) {\n  background: rgba(25, 118, 210, 0.16);\n}\n\n.efd__btn:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__btn--primary {\n  background: var(--efd-primary);\n  border-color: var(--efd-primary);\n  color: #fff;\n}\n\n.efd__btn--primary:hover:not(:disabled) {\n  background: #1565c0;\n  border-color: #1565c0;\n  color: #fff;\n}\n\n.efd__btn--primary:active:not(:disabled) {\n  background: var(--efd-primary-dark);\n  border-color: var(--efd-primary-dark);\n}\n\n.efd__btn--ghost {\n  background: transparent;\n  border-color: transparent;\n  color: var(--efd-primary-dark);\n  font-weight: 700;\n}\n\n.efd__btn--ghost:hover:not(:disabled) {\n  background: var(--efd-primary-soft);\n  border-color: transparent;\n}\n\n.efd__btn--danger {\n  color: var(--efd-danger);\n}\n\n.efd__btn--danger:hover:not(:disabled) {\n  background: var(--efd-danger-soft);\n  border-color: transparent;\n  color: var(--efd-danger);\n}\n\n.efd__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Icon-only toolbar action. The meaning is carried by the glyph, its colour\n   and its tooltip — Add is the accent, Delete is the one warning colour. */\n.efd__tool-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--efd-control-h);\n  height: var(--efd-control-h);\n  padding: 0;\n  flex: 0 0 auto;\n  border: 1px solid transparent;\n  border-radius: var(--efd-radius);\n  background: transparent;\n  color: var(--efd-primary);\n  cursor: pointer;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n\n.efd__tool-btn:hover:not(:disabled) {\n  background: var(--efd-primary-soft);\n  color: var(--efd-primary-dark);\n}\n\n.efd__tool-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__tool-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.efd__tool-btn--danger {\n  color: var(--efd-danger);\n}\n\n.efd__tool-btn--danger:hover:not(:disabled) {\n  background: var(--efd-danger-soft);\n  color: var(--efd-danger);\n}\n\n/* Square icon-only affordance: panel collapse/expand. */\n.efd__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  flex: 0 0 auto;\n  border: 1px solid transparent;\n  border-radius: var(--efd-radius);\n  background: transparent;\n  color: var(--efd-muted);\n  cursor: pointer;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n\n.efd__icon-btn:hover {\n  background: var(--efd-primary-soft);\n  color: var(--efd-primary-dark);\n}\n\n.efd__icon-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__icon {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n}\n\n/* ---------------------------------------------------------------- toolbox */\n\n/* Access-style control toolbar, in three named runs. Separate from Database\n   Fields: this row is what you can put on the form, not the PostgreSQL\n   columns that bind later. */\n.efd__toolbox {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin-bottom: var(--efd-gap);\n  padding: 3px 8px 4px;\n  background: var(--efd-surface);\n  border: 1px solid var(--efd-line);\n  border-radius: 4px;\n  box-shadow: var(--efd-shadow-1);\n  min-width: 0;\n}\n\n.efd__toolbox-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  padding: 0 10px 0 2px;\n  border-right: 1px solid var(--efd-line);\n  color: var(--efd-chrome);\n}\n\n.efd__toolbox-label .efd__icon {\n  color: var(--efd-primary);\n}\n\n.efd__toolbox-kicker {\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.efd__toolbox-items {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 0 4px;\n  min-width: 0;\n}\n\n/* A group is a label over its own run of controls, with a hairline between\n   runs. Subtle enough that the row still reads as one toolbar. */\n.efd__toolbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0 8px;\n  min-width: 0;\n}\n\n.efd__toolbox-group + .efd__toolbox-group {\n  border-left: 1px solid var(--efd-line);\n}\n\n.efd__toolbox-group-title {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 13px;\n  color: var(--efd-muted);\n  white-space: nowrap;\n}\n\n.efd__toolbox-group-items {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2px;\n  min-width: 0;\n}\n\n.efd__toolbox-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 24px;\n  padding: 0 7px;\n  border: 1px solid transparent;\n  border-radius: var(--efd-radius);\n  background: transparent;\n  color: var(--efd-ink);\n  line-height: 1;\n  white-space: nowrap;\n  cursor: grab;\n  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n\n.efd__toolbox-item:hover:not(:disabled) {\n  background: var(--efd-primary-soft);\n  border-color: rgba(25, 118, 210, 0.3);\n  color: var(--efd-primary-dark);\n}\n\n.efd__toolbox-item:active:not(:disabled) {\n  background: rgba(25, 118, 210, 0.16);\n}\n\n.efd__toolbox-item:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__toolbox-item:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.efd__toolbox-glyph {\n  width: 14px;\n  height: 14px;\n  flex: 0 0 auto;\n  color: var(--efd-primary);\n}\n\n.efd__toolbox-name {\n  font-size: 12px;\n}\n\n/* ----------------------------------------------------------- form fields */\n\n.efd__field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 6px;\n  min-width: 0;\n}\n\n.efd__field--inline {\n  margin-bottom: 0;\n  min-width: 140px;\n}\n\n.efd__field--grow {\n  flex: 1;\n  min-width: 180px;\n}\n\n.efd__field label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--efd-muted);\n}\n\n.efd__field input,\n.efd__field select,\n.efd__field textarea,\n.efd__search-input {\n  height: var(--efd-control-h);\n  border: 1px solid var(--efd-line-strong);\n  border-radius: var(--efd-radius);\n  padding: 0 7px;\n  background: var(--efd-surface);\n  color: var(--efd-ink);\n  min-width: 0;\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.efd__field textarea {\n  height: auto;\n  padding: 4px 7px;\n  line-height: 1.4;\n  resize: vertical;\n}\n\n.efd__field input:hover:not(:disabled),\n.efd__field select:hover:not(:disabled),\n.efd__field textarea:hover:not(:disabled),\n.efd__search-input:hover {\n  border-color: #9aa7b3;\n}\n\n.efd__field input:focus,\n.efd__field select:focus,\n.efd__field textarea:focus,\n.efd__search-input:focus {\n  outline: none;\n  border-color: var(--efd-primary);\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__field input:disabled,\n.efd__field select:disabled,\n.efd__field textarea:disabled {\n  background: #f5f7f9;\n  color: var(--efd-muted);\n  cursor: not-allowed;\n}\n\n.efd__toggle {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 22px;\n  margin-bottom: 4px;\n  color: var(--efd-ink);\n  cursor: pointer;\n}\n\n/* -------------------------------------------------------------- workspace */\n\n/* Three regions: Database Fields, canvas, Properties. The canvas is the\n   workspace, so the inspectors are sized to their content and everything else\n   goes to the middle. Collapsing a panel hands its whole column to the canvas\n   and leaves a rail just wide enough to bring it back. */\n.efd__workspace {\n  display: grid;\n  grid-template-columns:\n    clamp(176px, 13vw, 224px)\n    minmax(0, 1fr)\n    clamp(212px, 15vw, 248px);\n  gap: var(--efd-gap);\n  flex: 1;\n  min-height: 0;\n}\n\n.efd__workspace--no-left {\n  grid-template-columns: 30px minmax(0, 1fr) clamp(212px, 15vw, 248px);\n}\n\n.efd__workspace--no-right {\n  grid-template-columns: clamp(176px, 13vw, 224px) minmax(0, 1fr) 30px;\n}\n\n.efd__workspace--no-left.efd__workspace--no-right {\n  grid-template-columns: 30px minmax(0, 1fr) 30px;\n}\n\n.efd__panel {\n  display: flex;\n  flex-direction: column;\n  background: var(--efd-surface);\n  border: 1px solid var(--efd-line);\n  border-radius: 4px;\n  box-shadow: var(--efd-shadow-1);\n  padding: 0 8px 8px;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n}\n\n/* The panel's own title band, edge to edge above its content. */\n.efd__panel-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  margin: 0 -8px 6px;\n  padding: 4px 6px 4px 8px;\n  background: var(--efd-band);\n  border-bottom: 1px solid var(--efd-line);\n}\n\n.efd__panel-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  flex: 1 1 auto;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--efd-chrome);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__panel-title .efd__icon {\n  color: var(--efd-primary);\n}\n\n.efd__panel-note {\n  margin: 0 0 6px;\n  font-size: 11px;\n  color: var(--efd-muted);\n}\n\n/* The collapsed rail: one expand button and the panel's name turned on its\n   side, so the panel is still findable at 30px. */\n.efd__rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 2px;\n  background: var(--efd-surface);\n  border: 1px solid var(--efd-line);\n  border-radius: 4px;\n  box-shadow: var(--efd-shadow-1);\n  overflow: hidden;\n}\n\n.efd__rail-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  writing-mode: vertical-rl;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--efd-muted);\n  white-space: nowrap;\n}\n\n.efd__rail-label .efd__icon {\n  width: 16px;\n  height: 16px;\n  color: var(--efd-primary);\n}\n\n/* -------------------------------------------------------- database fields */\n\n.efd__search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  margin-bottom: 6px;\n}\n\n.efd__search-icon {\n  position: absolute;\n  left: 6px;\n  width: 13px;\n  height: 13px;\n  color: var(--efd-muted);\n  pointer-events: none;\n}\n\n.efd__search-input {\n  width: 100%;\n  padding-left: 24px;\n}\n\n/* The table the fields belong to, named the way the user thinks of it. The\n   raw table name is not the headline — it is the row's tooltip. */\n.efd__palette-table {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  padding: 3px 6px;\n  margin-bottom: 4px;\n  border-radius: var(--efd-radius);\n  background: var(--efd-band);\n  border: 1px solid var(--efd-line);\n  color: var(--efd-chrome);\n}\n\n.efd__palette-table .efd__icon {\n  color: var(--efd-primary);\n}\n\n.efd__palette-table-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.efd__palette-table-eyebrow {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--efd-muted);\n}\n\n.efd__palette-table-name {\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__palette-group {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-height: 0;\n  overflow: auto;\n}\n\n.efd__palette-empty {\n  margin: 2px 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--efd-muted);\n}\n\n/* A field row: a type glyph, the human label, and the control family under it\n   as quieter metadata. Two compact lines, the way an Access field list reads —\n   the database column itself is in the row's tooltip, not in the list. */\n.efd__palette-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  text-align: left;\n  border: 1px solid transparent;\n  border-left: 2px solid transparent;\n  border-radius: var(--efd-radius);\n  padding: 2px 6px;\n  background: transparent;\n  cursor: grab;\n  transition: background-color 120ms ease, border-color 120ms ease;\n}\n\n.efd__palette-item:hover:not(:disabled) {\n  background: var(--efd-primary-soft);\n  border-color: rgba(25, 118, 210, 0.25);\n  border-left-color: var(--efd-primary);\n}\n\n.efd__palette-item:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n/* A database field and a toolbox control must never look alike. */\n.efd__palette-item--field {\n  border-left-color: var(--efd-primary);\n}\n\n.efd__palette-item.is-used {\n  opacity: 0.5;\n}\n\n.efd__palette-item:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.efd__palette-glyph {\n  width: 13px;\n  height: 13px;\n  flex: 0 0 auto;\n  color: var(--efd-muted);\n}\n\n.efd__palette-item:hover .efd__palette-glyph {\n  color: var(--efd-primary);\n}\n\n.efd__palette-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.efd__palette-name {\n  min-width: 0;\n  font-size: 12px;\n  line-height: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__palette-required {\n  margin-left: 2px;\n  color: var(--efd-danger);\n}\n\n/* The control family, not the PostgreSQL type: what the field IS to a user. */\n.efd__palette-type {\n  min-width: 0;\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--efd-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Keys, audit columns and system plumbing: present, reachable, de-emphasised. */\n.efd__palette-item.is-technical .efd__palette-name {\n  color: var(--efd-muted);\n}\n\n.efd__palette-group-title {\n  margin: 6px 0 2px;\n  padding: 0 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--efd-muted);\n  border-top: 1px solid var(--efd-line);\n  padding-top: 5px;\n}\n\n.efd__palette-toggle {\n  flex: 0 0 auto;\n  margin: 4px 0 0;\n  padding-top: 5px;\n  border-top: 1px solid var(--efd-line);\n  font-size: 11px;\n  color: var(--efd-muted);\n}\n\n/* ----------------------------------------------------------------- canvas */\n\n/* The design surface itself. There is no second rendering of the form: what\n   is on this canvas is the form being designed. The grid belongs to this\n   canvas — empty space shows the same square cells cards and controls snap\n   to. */\n.efd__canvas {\n  display: flex;\n  flex-direction: column;\n  background: var(--efd-soft);\n  border: 1px solid var(--efd-line);\n  border-radius: 4px;\n  padding: 10px;\n  min-width: 0;\n  overflow: auto;\n}\n\n/* 48 × 32 SQUARE cells. The aspect ratio is what makes them square: the row\n   height is never stated in pixels, it falls out of the width. Below\n   --efd-min-cell a cell stops being a usable target, so the surface keeps its\n   proportions and the canvas scrolls instead.\n\n   Minor lines are barely there and major lines every eight cells are only a\n   shade stronger: the grid has to be readable without competing with the form\n   drawn on top of it. */\n.efd__canvas-grid {\n  --efd-major: 8;\n  position: relative;\n  flex: 0 0 auto;\n  width: 100%;\n  min-width: calc(var(--efd-cols) * var(--efd-min-cell, 21px));\n  background-color: var(--efd-surface);\n  background-image:\n    linear-gradient(to right, var(--efd-grid-major) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--efd-grid-major) 1px, transparent 1px),\n    linear-gradient(to right, var(--efd-grid-faint) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--efd-grid-faint) 1px, transparent 1px);\n  background-size:\n    calc(100% / var(--efd-cols) * var(--efd-major)) 100%,\n    100% calc(100% / var(--efd-rows) * var(--efd-major)),\n    calc(100% / var(--efd-cols)) 100%,\n    100% calc(100% / var(--efd-rows));\n  background-position: 0 0;\n  background-repeat: repeat;\n  border: 1px solid var(--efd-line-strong);\n  border-radius: 3px;\n  box-shadow: var(--efd-shadow-2);\n}\n\n.efd__empty {\n  position: absolute;\n  z-index: 1;\n  left: 50%;\n  top: 40px;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  max-width: 400px;\n  padding: 14px 18px;\n  border: 1px dashed var(--efd-line-strong);\n  border-radius: 4px;\n  text-align: center;\n  line-height: 1.45;\n  color: var(--efd-muted);\n  background: rgba(255, 255, 255, 0.94);\n}\n\n.efd__empty-copy {\n  margin: 0;\n}\n\n/* ------------------------------------------------------------------ cards */\n\n/* A card is a titled section sitting on the canvas grid. Its box is exactly\n   col/row/width/height cells — the header is the first row of that box, so the\n   card's own control grid is the canvas grid, cropped. */\n.efd__card {\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background: var(--efd-surface);\n  border: 1px solid #d3dce5;\n  border-radius: 3px;\n  margin: 0;\n  overflow: hidden;\n  box-shadow: var(--efd-shadow-1);\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.efd__card:hover {\n  border-color: #b8c5d2;\n}\n\n/* Selected: a clear blue outline and a tinted header, and nothing more. */\n.efd__card.is-selected {\n  border-color: var(--efd-primary);\n  box-shadow: 0 0 0 1px var(--efd-primary), var(--efd-shadow-2);\n}\n\n/* `.emr-mz-dashboard header` forces display:block at a higher specificity than\n   a single class, so the card header has to claim its flex row twice. The band\n   is exactly one canvas cell tall: the card is --efd-card-rows cells high. */\n.emr-mz-dashboard .efd__card-head,\n.efd__card-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 calc(100% / var(--efd-card-rows, 7));\n  min-height: 0;\n  padding: 0 2px 0 6px;\n  border-bottom: 1px solid var(--efd-line);\n  background: var(--efd-band);\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  overflow: hidden;\n}\n\n.efd__card.is-selected .efd__card-head {\n  background: var(--efd-selected);\n  border-bottom-color: var(--efd-selected-line);\n}\n\n.efd__drag-handle {\n  display: grid;\n  grid-template-columns: repeat(3, 3px);\n  gap: 2px;\n  flex: 0 0 auto;\n  cursor: grab;\n}\n\n.efd__drag-dot {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: #9aa8b5;\n}\n\n.efd__card.is-selected .efd__drag-dot {\n  background: var(--efd-primary);\n}\n\n.efd__card-title {\n  flex: 1 1 auto;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__card-meta {\n  flex: 0 0 auto;\n  font-size: 11px;\n  line-height: 1.2;\n  color: var(--efd-muted);\n  white-space: nowrap;\n}\n\n.efd__card-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  flex: 0 0 auto;\n  border: none;\n  border-radius: 2px;\n  background: transparent;\n  color: var(--efd-muted);\n  cursor: pointer;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n\n.efd__card-close:hover {\n  background: var(--efd-danger-soft);\n  color: var(--efd-danger);\n}\n\n.efd__card-close:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__card-close-icon {\n  width: 12px;\n  height: 12px;\n}\n\n/* The card's control grid: its own columns across, its own cells down. Both\n   come from the card's canvas box, so a control cell IS a canvas cell — and\n   the card draws those same cells, fainter than the canvas does, so a control\n   is placed against a visible grid and reads as sitting on top of it. */\n.efd__card-grid {\n  display: grid;\n  flex: 1 1 auto;\n  min-height: 0;\n  grid-template-columns: repeat(var(--efd-cols), minmax(0, 1fr));\n  grid-template-rows: repeat(var(--efd-rows), minmax(0, 1fr));\n  gap: 0;\n  padding: 0;\n  background-color: transparent;\n  background-image:\n    linear-gradient(to right, var(--efd-grid-faint) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--efd-grid-faint) 1px, transparent 1px);\n  background-size:\n    calc(100% / var(--efd-cols)) 100%,\n    100% calc(100% / var(--efd-rows));\n  background-repeat: repeat;\n}\n\n.efd__card-handle {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 13px;\n  height: 13px;\n  cursor: nwse-resize;\n  background: linear-gradient(135deg, transparent 50%, #aab8c4 50%);\n  touch-action: none;\n  z-index: 2;\n}\n\n.efd__card.is-selected .efd__card-handle {\n  background: linear-gradient(135deg, transparent 50%, var(--efd-primary) 50%);\n}\n\n/* --------------------------------------------------------------- controls */\n\n/* A control should read as the form control it will become, sitting above the\n   grid — not as a filled spreadsheet cell. The box itself is quiet; the input,\n   button or box inside it carries the shape. */\n.efd__control {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1px;\n  margin: 1px;\n  padding: 1px 3px;\n  border: 1px solid transparent;\n  border-radius: var(--efd-radius);\n  background: var(--efd-surface);\n  cursor: grab;\n  overflow: hidden;\n  touch-action: none;\n  user-select: none;\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n}\n\n.efd__control:hover {\n  border-color: var(--efd-line-strong);\n  box-shadow: var(--efd-shadow-1);\n}\n\n/* Selection has to survive against a grid of similar rectangles, so it changes\n   border, fill and halo together rather than relying on any one of them. */\n.efd__control.is-selected {\n  border-color: var(--efd-primary);\n  background: var(--efd-selected);\n  box-shadow: 0 0 0 1px var(--efd-primary);\n  z-index: 1;\n}\n\n/* A control with no caption draws its own shape — a button, a rule, a box —\n   so it is aligned to the top left of its cells rather than centred. */\n.efd__control--label,\n.efd__control--button,\n.efd__control--line,\n.efd__control--rectangle,\n.efd__control--image,\n.efd__control--tab {\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.efd__control--line {\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.efd__control-handle {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 9px;\n  height: 9px;\n  cursor: nwse-resize;\n  background: linear-gradient(135deg, transparent 50%, var(--efd-primary) 50%);\n  touch-action: none;\n  opacity: 0;\n  transition: opacity 120ms ease;\n}\n\n.efd__control:hover .efd__control-handle,\n.efd__control.is-selected .efd__control-handle {\n  opacity: 1;\n}\n\n/* A two-row control is the tightest case: a caption line over an input inside\n   two square cells. The caption is the one place 11px is unavoidable — it has\n   to share a ~40px box with a real input — and it keeps its whole line box or\n   the glyph tops are clipped. */\n.efd__preview-caption {\n  flex: 0 0 auto;\n  font-size: 11px;\n  line-height: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  color: var(--efd-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__preview-required {\n  color: var(--efd-danger);\n}\n\n.efd__preview-input {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid var(--efd-line-strong);\n  border-radius: 2px;\n  background: var(--efd-surface);\n  color: var(--efd-muted);\n  padding: 0 5px;\n  min-height: 18px;\n}\n\n.efd__preview-input--tall {\n  flex: 1;\n  align-items: flex-start;\n  padding-top: 2px;\n}\n\n.efd__preview-caret {\n  color: var(--efd-muted);\n  font-size: 11px;\n  margin-left: 4px;\n}\n\n.efd__preview-check {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__preview-box {\n  width: 13px;\n  height: 13px;\n  border: 1px solid #8b9aa8;\n  border-radius: 2px;\n  background: var(--efd-surface);\n  flex-shrink: 0;\n}\n\n.efd__preview-radio {\n  width: 13px;\n  height: 13px;\n  border: 1px solid #8b9aa8;\n  border-radius: 50%;\n  background: var(--efd-surface);\n  flex-shrink: 0;\n}\n\n.efd__preview-label {\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__preview-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--efd-primary);\n  color: #fff;\n  border-radius: 2px;\n  padding: 0 10px;\n  min-height: 20px;\n  max-width: 100%;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__preview-line {\n  display: block;\n  width: 100%;\n  height: 0;\n  border-top: 2px solid #8b9aa8;\n}\n\n.efd__preview-rect {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: 16px;\n  border: 1px solid #8b9aa8;\n  border-radius: 2px;\n  color: var(--efd-muted);\n  font-size: 11px;\n}\n\n.efd__preview-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  min-height: 22px;\n  border-radius: 2px;\n  background:\n    linear-gradient(135deg, transparent 46%, #cdd7e0 46%, #cdd7e0 54%, transparent 54%),\n    #f4f6f9;\n  color: var(--efd-muted);\n  font-size: 11px;\n}\n\n.efd__preview-tabs {\n  display: flex;\n  gap: 3px;\n  width: 100%;\n  border-bottom: 1px solid var(--efd-line-strong);\n}\n\n.efd__preview-tab {\n  padding: 1px 8px;\n  font-size: 11px;\n  color: var(--efd-muted);\n  border: 1px solid transparent;\n}\n\n.efd__preview-tab.is-active {\n  color: var(--efd-ink);\n  background: var(--efd-surface);\n  border-color: var(--efd-line-strong);\n  border-bottom-color: var(--efd-surface);\n  font-weight: 700;\n}\n\n.efd__preview-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  border: 1px solid var(--efd-line-strong);\n  border-radius: 2px;\n  background: var(--efd-surface);\n  font-size: 11px;\n  color: var(--efd-muted);\n  padding: 1px 5px;\n  overflow: hidden;\n}\n\n/* ------------------------------------------------------------- properties */\n\n/* A property inspector: a few titled sections of label/value rows, each row\n   one line high. Nothing here is allowed to waste vertical space. */\n.efd__props-kind {\n  flex: 0 0 auto;\n  padding: 1px 6px;\n  border-radius: 8px;\n  background: var(--efd-selected);\n  border: 1px solid var(--efd-selected-line);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--efd-primary-dark);\n}\n\n.efd__group {\n  margin: 0;\n  border-bottom: 1px solid var(--efd-line);\n}\n\n.efd__group:last-of-type {\n  border-bottom: none;\n}\n\n/* The section header is also its toggle: a caret, a name, nothing else. */\n.efd__group-title {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  margin: 0;\n  padding: 5px 0 4px;\n  border: none;\n  background: transparent;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--efd-muted);\n  text-align: left;\n  cursor: pointer;\n}\n\n.efd__group-title:hover {\n  color: var(--efd-primary-dark);\n}\n\n.efd__group-title:focus-visible {\n  outline: none;\n  box-shadow: var(--efd-focus-ring);\n}\n\n.efd__group-caret {\n  width: 13px;\n  height: 13px;\n  flex: 0 0 auto;\n  color: var(--efd-muted);\n  transform: rotate(-90deg);\n  transition: transform 120ms ease;\n}\n\n.efd__group.is-open .efd__group-caret {\n  transform: rotate(0deg);\n}\n\n.efd__group-body {\n  padding: 0 0 6px;\n}\n\n/* Two columns: the property's name, then its value. Every row is the same\n   shape, so the panel reads down its left edge. */\n.efd__props .efd__field {\n  display: grid;\n  grid-template-columns: 84px minmax(0, 1fr);\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.efd__props .efd__field label {\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--efd-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.efd__props .efd__field textarea {\n  grid-column: 1 / -1;\n}\n\n.efd__props .efd__field:has(textarea) {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 2px;\n}\n\n.efd__props .efd__toggle {\n  margin-bottom: 4px;\n}\n\n.efd__group-body > .efd__field:last-child,\n.efd__group-body > .efd__toggle:last-child {\n  margin-bottom: 0;\n}\n\n.efd__prop-value {\n  min-height: 22px;\n  display: flex;\n  align-items: center;\n  word-break: break-word;\n}\n\n.efd__prop-value--binding {\n  font-family: \"IBM Plex Mono\", ui-monospace, Menlo, Consolas, monospace;\n  font-size: 12px;\n  color: var(--efd-primary-dark);\n}\n\n.efd__props-note {\n  margin: 6px 0 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: var(--efd-muted);\n}\n\n.efd__prop-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--efd-line);\n}\n\n.efd__prop-actions .efd__btn {\n  height: 24px;\n  padding: 0 8px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
